module.exports = __webpack_public_path__ + "static/media/pic_5_24.6daabf42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pic_5_24.jpg
// module id = 1838
// module chunks = 0 1